import { MapSceneGeneratedEntity } from "./generated/MapSceneGeneratedEntity";

export abstract class MapSceneEntity extends MapSceneGeneratedEntity {
    // Comment to preserve new line
}
